// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"39":"10223f0e","595":"d5b46d43","768":"7b60c5bf","985":"cd78d2ee"}[chunkId] + ".css";
};